<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
  v-if="critereRecherche">
    <div class="column is-12 pdb-0"
    :class="[
      {'hauteur-haut-brief-filtre': errors.length === 0},
      {'hauteur-haut-brief-filtre-errors': errors.length > 0}
      ]">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('general.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('general.filtre.sousTitle') }}
        </span>
      </div>
      <div class="column is-12" v-if="errors.length > 0">
        <error-msg-component :messages="errors"
        :error="errors.length > 0"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="errors = []"/>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless"
    :class="[
      {'hauteur-brief-filtre': errors.length === 0},
      {'hauteur-brief-filtre-errors': errors.length > 0}
      ]">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.dateVisualisation')">
            <b-datepicker show-week-number
            icon="calendar-today"
            :editable="true"
            v-model="critereRecherche.dateVisualisation"
            :nearby-selectable-month-days="true">
            </b-datepicker>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.reference')">
            <b-input v-model="critereRecherche.reference">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.libelle')">
            <b-input v-model="critereRecherche.libelle">
            </b-input>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.ville')">
            <ville-tag-input-auto-complete
                :critere-recherche="this.critereRecherche"
                table-name="Produit"/>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.departement')">
            <qd-taginput
              v-model="critereRecherche.departements"
              type="is-primary">
            </qd-taginput>
          </b-field>
        </div>
        <div class="column is-12">
          <libelle-tag-input
                      :label="$t('listeProduitReseauNumerique.filtre.format')"
                      :items="format"
                      field="libelle"
                      v-model="formatSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12">
            <libelle-tag-input
                      :label="$t('listeProduitReseauNumerique.filtre.type')"
                      :items="typeReseau"
                      field="libelle"
                      v-model="typesReseauSelected">
          </libelle-tag-input>
        </div>
        <div class="column is-12 pdb-0">
          <agence-tag-input
          :label="$t('listeProduitReseauNumerique.filtre.agence')"
          :items="filtrerProduitParAgence ? agencesSelectionnees : agencesInformations"
          v-model="critereRecherche.agencesId">
          </agence-tag-input>
        </div>
        <div class="column is-12 pdb-0" v-if="societesInformations.length > 1
        && !filtrerProduitParSociete && !filtrerProduitParAgence">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.societe')">
            <b-select v-model="critereRecherche.societeId" expanded>
              <option :value=null></option>
              <option v-for="societe in societesInformations"
              :key="societe.id"
              :value="societe.id">
              {{ societe.libelle }}
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="column is-12 pdb-0">
          <b-field :label="$t('listeProduitReseauNumerique.filtre.actif')">
            <b-select v-model="critereRecherche.actif">
              <option :value="null"></option>
              <option :value="true"> {{ $t('listeProduitReseauNumerique.filtre.yes') }}
              </option>
              <option :value="false"> {{ $t('listeProduitReseauNumerique.filtre.no') }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('general.button.appliquer')}}</button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('general.button.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { SET_CRITERES_RECHERCHE } from '@/store/modules/produitReseauNumerique-mutation-type';
import genererCritereRechercheProduitReseauNumerique
  from '@/services/catalogue/genererCriteresRecherche/genererCritereRechercheProduitReseauNumerique';
import { PARAMETRES_INTERNE_KEYS, PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import agenceTagInput from '@/components/general/tagInput/agenceTagInput';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const Societes = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const ProduitReseauNumerique = createNamespacedHelpers('produitReseauNumerique');

export default {
  props: {
    isCartographie: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      critereRecherche: null,
      errors: [],
      listeTypeReseauBase: [],
      typesReseauSelected: [],
      typeReseauTags: null,
      listeFormatBase: [],
      formatSelected: [],
      formatTags: null,
    };
  },
  components: {
    errorMsgComponent,
    libelleTagInput,
    agenceTagInput,
    VilleTagInputAutoComplete,
  },
  computed: {
    ...Societes.mapGetters({
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      agencesSelectionnees: 'agenceActive',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...ProduitReseauNumerique.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    format() {
      return this.parametre(PARAMETRES_KEYS.format).filter(f => f.actif);
    },
    typeReseau() {
      return this.parametre(PARAMETRES_KEYS.typeReseau).filter(typeReseau => typeReseau.actif);
    },
  },
  methods: {
    ...ProduitReseauNumerique.mapMutations({
      setCritereRecherche: SET_CRITERES_RECHERCHE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
      loadParametresInterne: 'loadParametresInterne',
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheProduitReseauNumerique());
      this.typesReseauSelected = [];
      this.formatSelected = [];
      this.getFormatTag();
      this.getTypeReseauTag();
    },
    appliquerCritere() {
      this.errors = [];
      if (!this.critereRecherche.dateVisualisation) {
        this.errors.push({
          message: 'listeProduitReseauNumerique.filtre.errors.dateVisualisation',
        });
        return;
      }
      this.critereRecherche.formats = this.formatSelected.map(f => { return f.id; });
      this.critereRecherche.typeReseauIds = this.typesReseauSelected.map(t => { return t.id; });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getFormatTag() {
      this.formatTags = this.listeFormatBase.filter((format) => {
        return !this.formatSelected.map(a => a.id).includes(format.id);
      });
    },
    getTypeReseauTag() {
      this.typeReseauTags = this.listeTypeReseauBase.filter((typeReseau) => {
        return !this.typesReseauSelected.map(a => a.id).includes(typeReseau.id);
      });
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametres([PARAMETRES_KEYS.format, PARAMETRES_KEYS.typeReseau]);
        await this.loadParametresInterne([
          PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
          PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        ]);
        loadingComponent.close();
        this.listeFormatBase = this.format;
        if (this.critereRecherche.formats) {
          this.formatSelected = this.listeFormatBase.filter((c) => {
            return this.critereRecherche.formats.includes(c.id);
          });
        }
        this.getFormatTag();
        this.listeTypeReseauBase = this.typeReseau;
        if (this.critereRecherche.typeReseauIds) {
          this.typesReseauSelected = this.listeTypeReseauBase.filter((c) => {
            return this.critereRecherche.typeReseauIds.includes(c.id);
          });
        }
        this.getTypeReseauTag();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
